<template>
  <!-- <ConfirmDialog></ConfirmDialog> -->
  <Transition name="modal-fade">
    <Modal v-if="showAddChargeModal" @close="showAddChargeModal = false" style="z-index: 2000">
      <template v-slot:header>
        <span class="d-flex flex-row justify-content-between align-items-center col-12 p-0 py-2">
          <div></div>
          <h2 class="fw-bold fs-3">Add Charges to Case</h2>
          <button class="btn btn-gray btn-xl" @click="showAddChargeModal = false">
            <i class="fa fa-close"></i>
          </button>
        </span>
      </template>
      <template v-slot:body>
        <AddChargeModal
          @closeAddChargeModal="showAddChargeModal = false"
          :crimeIdToAdd="selectedCrimeId"
          :charges="charges"
          :bDate="bDate"
          :eDate="eDate"
          :rangeCheck="rangeCheck"
          @addCharge="addCharge"
          @close="showAddChargeModal = false"
          :insertChargeCountNumber="insertChargeCountNumber"
        />
      </template>
    </Modal>
  </Transition>


  <Transition name="modal-fade">
    <Modal
      @close="onClose"
      customClass="col-12 col-lg-8 p-0 no-body-padding"
      :customStyle="{ height: '85vh', maxHeight: '100vh' }"
    >
      <template v-slot:header>
        <div class="w-100 fw-bold d-flex align-items-center justify-content-between">
          <div></div>
          <h3 class="fw-bold section-header">Add Charge</h3>

          <button type="button" @click="onClose" class="btn btn-gray btn-xl">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>
      <template v-slot:body>  
        <HelperSearch v-if="showHelper" :helperNumber="helperNumber" @closeHelper="closeHelper"></HelperSearch>

        <div class="card-body p-0 overflow-auto d-flex flex-column h-100 w-100 mh-100">
          <div class="p-0 overflow-auto d-flex flex-column">
            <div class="row w-100" ref="searchBarContainer">
              <div class="col-12 m-0 p-0 d-flex justify-content-between flex-wrap px-5 py-3">
                <div class="d-flex align-items-center col-12 col-lg-6 px-0">
                  <div class="d-flex flex-column pl-3 mr-5">
                    <!-- <label for="beginDate" class="fs-5 fw-bold">Offense Date:</label> -->
                    <div class="d-flex justify-content-between align-items-center w-100">
                      <label for="endDate" class="fw-bold fs-5 mr-3">{{ rangeCheck ? "Begin" : "Offense" }} Date:</label>
                      <input
                        :max="today"
                        type="date"
                        id="beginDate"
                        name="beginDate"
                        class="form-control bordered fc-normal"
                        style="cursor: pointer"
                        v-model="bDate"
                        :default="bDate"
                      />
                    </div>

                    <div class="d-flex justify-content-between w-100 mt-3" v-if="rangeCheck">
                      <label for="endDate" class="fw-bold fs-5 mr-3">End Date:</label>
                      <input
                        v-show="rangeCheck"
                        :max="today"
                        type="date"
                        id="endDate"
                        name="endDate"
                        class="form-control bordered"
                        v-model="eDate"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="d-flex align-items-center">
                      <input
                        v-model="rangeCheck"
                        type="checkbox"
                        name="rangeCheckbox"
                        id="rangeCheckbox"
                        value="rangeCheckbox"
                      />
                      <label for="rangeCheckbox" class="fw-bold fs-5 clickable ml-3">Date Range</label>
                    </div>
                  </div>
                </div>
                <!-- <div class="d-flex flex-column col-12 col-lg-3 hidden">
                    <div class="d-flex tab-hidden">
                      <input
                        @click="rangeCheck = !rangeCheck"
                        type="checkbox"
                        name="rangeCheckbox"
                        id="rangeCheckbox"
                        value="rangeCheckbox"
                      />
                      <label for="rangeCheckbox" class="ml-3 fw-bold fs-5"
                        >Date Range</label
                      >
                    </div>

                    <div class="d-flex flex-column" v-show="rangeCheck">
                      <label for="endDate" class="fw-bold">End Date:</label>
                      <input
                        v-show="rangeCheck"
                        :max="today"
                        type="date"
                        id="endDate"
                        name="endDate"
                        style="width: 250px"
                        class="form-control-lg bordered"
                        v-model="eDate"
                      />
                    </div>
                  </div> -->

                <div class="d-flex flex-column col-12 col-lg-6 h-lg-100 align-items-end">
                  <div class="d-flex flex-column">
                    <label for="count" class="fw-bold fs-5" :class="{ 'mt-5': rangeCheck }">Statute</label>
                    <div class="d-flex align-items-center">
                      <input
                        type="text"
                        v-model="search"
                        label="Search"
                        class="form-control mr-1 bordered"
                        placeholder="Enter Section Number"
                        aria-label="Statute Search"
                        aria-describedby="search"
                        ref="crimeSearchInput"
                        @keyup.enter="manualSearch"
                        style="height: 3.2rem; width: 15rem"
                      />
                      <button class="btn btn-primary" @click="manualSearch" style="height: 2.8rem">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                    <p class="fs-5 fw-bold" v-if="insertChargeCountNumber !== null">
                      Inserting At Count {{ insertChargeCountNumber }}
                    </p>
                  </div>
                </div>

                <!-- PARAMETER SEARCH CARD -->
                <!-- PARAMETER SEARCH CARD -->
                <!-- PARAMETER SEARCH CARD -->
              </div>
            </div>
            <div class="overflow-auto" :style="tableHeight">
              <div class="d-flex flex-column overflow-auto m-0 w-100 h-100" @scroll="wheelUp">
                <table class="table shadow-sm border-top fs-5">
                  <thead class="border-bottom">
                    <tr>
                      <!-- <th class="py-2   fs-5 fw-bold" style="width:3%;" v-if="app_attr.isAdmin == 1">&nbsp;</th> -->

                      <th class="py-3 pl-5 fs-5 fw-bold" style="width: 18%; min-width: 200px">Statute</th>
                      <th class="py-3 fs-5 fw-bold" style="width: 35%; min-width: 300px">Description</th>

                      <th class="py-3 fs-5 fw-bold" style="width: 5%">Severity</th>

                      <th
                        v-if="bookmarked.length == 0"
                        class="fs-5 fw-bold text-center"
                        style="width: 5%; max-width: 5%; padding-left: 3.2rem"
                      >
                        <!-- Add -->
                      </th>
                    </tr>
                  </thead>
                  <tbody class="fs-5" v-if="!badSearch">
                    <tr
                      :id="'row_' + i"
                      :ref="'row_' + i"
                      @click="clickRow(r, i, rows.length)"
                      @scroll="i == rows.length - 3 ? findBottom : ''"
                      v-for="(r, i) in rows"
                      :key="i"
                      class="crimeRow fs-5"
                      :class="r.sel ? 'selected' : 'selectable'"
                    >
                      <!-- <td
                          :class="{
                            tableRow: r.sel == 1,
                            tableRowUnselected: r.sel != 1,
                          }"
                        >
                        </td> -->
                      <td
                        :class="{
                          tableRow: r.sel == 1,
                          tableRowUnselected: r.sel != 1,
                        }"
                      >
                        <i
                          class="fa fa-info-circle clickable book_auth pr-2 fs-5"
                          @click="
                            emitLawText({
                              header: 'Statute Text',
                              body: r.statuteDefinitionLawText,
                            })
                          "
                        ></i>
                        <span>{{ r.codeDefinitionCode }} {{ r.statuteDefinitionSection }}</span>
                      </td>
                      <td
                        :class="{
                          tableRow: r.sel == 1,
                          tableRowUnselected: r.sel != 1,
                        }"
                      >
                        <i
                          class="fa fa-info-circle clickable book_auth pr-2 fs-5"
                          @click="
                            emitLawText({
                              header: 'Elements of the Offense',
                              body: r.Elements,
                            })
                          "
                        ></i>
                        {{ r.Name }}
                      </td>

                      <td
                        :class="{
                          tableRow: r.sel == 1,
                          tableRowUnselected: r.sel != 1,
                        }"
                      >
                        {{ r.crmSeverityName !== "Felony" ? r.crmSeverityName.slice(0, 4) : r.crmSeverityName }}
                      </td>

                      <td :class="{ tableRow: r.sel == 1, 'text-center': true }">
                        <button
                          v-if="noActivity"
                          type="button"
                          @click="onAdd(r.Id, r)"
                          :disabled="insertChargeCountNumber !== null && r.CrimeTypeId !== 5"
                          class="btn fs-5 btn-primary btn-xl m-0 fw-bold"
                          style="width: 100px; max-width: 100px; height: 40px"
                        >
                          Add
                        </button>
                        <LoadingButton
                          v-else
                          class="btn fs-5 btn-primary btn-xl d-flex align-items-center"
                          style="width: 100px; max-width: 100px; height: 40px"
                        />
                      </td>
                    </tr>
                  </tbody>
                  <tbody class="mt-3" v-else-if="badSearch">
                    <tr class="fs-4 w-100 no-wrap" style="text-align: center">
                      <td class="fs-4 w-100 no-wrap" colspan="5">No Results Found</td>
                    </tr>
                  </tbody>
                  <tbody class="" v-else>
                    <tr>
                      <td>No Text</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </Transition>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import moment from "moment";

import fetch from "node-fetch";
import SC from "../../components/utils/sharedComponent.vue";
// import ConfirmDialog from "primevue/confirmdialog";
// import CPKModule from "../Home/CPKModule.vue";
// import CountPanelModule from "../Home/CountPanelModule.vue";
import LoadingButton from "../../components/utils/LoadingButton.vue";
import HelperSearch from "./ControlPanel/HelperSearch";
import Modal from "../../components/utils/Modal.vue";
import AddChargeModal from "./AddChargeModal.vue";
import { handleError } from "../../helpers";

export default {
  name: "Crimes",
  props: ["app_token", "currentCount", "app_attr", "charges", "noActivity", "insertChargeCountNumber"],
  components: {
    SC,
    // ConfirmDialog,
    // CPKModule,
    // CountPanelModule,
    LoadingButton,
    HelperSearch,
    Modal,
    AddChargeModal,
  },

  data() {
    return {
      data: [],
      rows: [],
      bookmarked: [],
      loadtop: false,
      loadbottom: false,
      dt: moment,
      defcrime: "",
      search: "",
      awaitingSearch: false,
      selFlag: false,
      selectedRowFlag: false,
      rangeCheck: false,
      window: {
        width: 0,
        height: 0,
        gridheight: 0,
      },
      currentCountModel: "1",
      severity: "A",
      severityPicked: "All",
      CrimeState: "Completed",
      bDate: "",
      eDate: "",
      clonePanelShow: false,
      cloneSourceRecord: [],
      BeginDate: "",
      EndDate: "",
      showCrimePropertiesSearch: false,
      message: "",
      reanimate: true,
      sp: {
        seriousFelony: false,
        violentFelonies: false,
        strike: false,
        superStrike: false,
        threeStrikeTrigger: false,
        sexRegistration: false,
        arsonRegistration: false,
        gangRegistration: false,
        firearmIneligible: false,
        voteIneligible: false,
        jurySvcIneligible: false,
        dnaSamples: false,
        pc1170h: false,
        description: "",
      },
      countSpinnerTouched: false,
      showCPK: false,
      selectedCrime: 0,
      showCount: false,
      showCountPanel: false,
      selectionCountValue: 0,
      selectionCharge: {},
      CPK: {},
      selectedCrimeId: 0,
      selectedR: {},

      scrollcount: 0,
      currentEnhMatches: [],
      startScroll: null,
      badSearch: false,
      showHelper: false,
      helperNumber: null,
      showAddChargeModal: false,
      searchBarElement: null,
    };
  },

  watch: {
    search: function (val) {
      // console.log(val, this.awaitingSearch);
      if (val == "664") {
        this.triggerHelper(664);
      } else if (val == "182") {
        this.triggerHelper(182);
      } else if (val !== "") {
        this.closeHelper();
        // if (!this.awaitingSearch) {
        //   setTimeout(() => {
        //     this.fetchResults({ query: this.search });
        //     this.awaitingSearch = false;
        //   }, 500); // 1 sec delay
        // }
        // this.awaitingSearch = true;
      }
    },
    bDate(newVal, oldVal) {
      let cutoffDateToSearch = new moment("01/01/2000");
      let newValMoment = new moment(newVal);
      if (newValMoment.isAfter(cutoffDateToSearch) && this.search.length > 0) {
        this.manualSearch();
      }
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.data = { data: [{}, {}] };
    this.search = this.defcrime;
  },

  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    gridscrollStyle() {
      return {
        height: `${this.window.gridheight}px`,
        top: `10px`,
        position: "relative",
      };
    },
    tableHeight() {
      return `max-height: calc(100% - ${this.searchBarElement?.clientHeight}px);`;
    },
    today() {
      return moment().format('YYYY-MM-DD');
    },
  },

  methods: {
    emitClose() {
      this.$emit("close");
    },
    triggerHelper(number) {
      // console.log(number);
      this.helperNumber = number;
      this.showHelper = true;
    },
    closeHelper() {
      this.helperNumber = null;
      this.showHelper = false;
    },
    changeCountValue(countValue) {
      this.currentCountModel = countValue;
    },

    closeCountPanelModule() {
      // this.$emit("closeCrimeTable", 'closeCrimeTable');
      this.selectedCrime = null;
      this.showCPK = false;
    },

    // closeCPK(addNonCPK) {
    //   this.showCPK = false;
    //   let param = {};
    //   // console.log("addNonCPK", addNonCPK);
    //   if (addNonCPK?.crimeId !== undefined) {
    //     param = {
    //       crimeId: addNonCPK.crimeId,
    //       currentCount: addNonCPK.currentCount || this.currentCountModel,
    //       CrimeState: addNonCPK.CrimeState,
    //       enhancementMatches: this.currentEnhMatches,
    //       isEnhancementMatch: addNonCPK?.isEnhancementMatch,
    //       OffenseDate: this.bDate,
    //       DateRangeEnd: this.eDate,
    //     };
    //   } else {
    //     param = "closeCrimeTable"
    //   };
    //   this.CPK = null;
    //   // console.log("CLOSE CPK", param);
    //   this.$emit("addChargesFromCrimeTable", param, true, this.insertChargeCountNumber);
    // },

    // searchPropertyBtn() {
    //   // console.log(this.sp.seriousFelony);

    //   this.fetchResults({ query: "%%" });
    // },

    // bookmarkNow() {
    //   // console.log("this.bookmarked::>", this.bookmarked);
    // },

    async manualSearch() {
      if (!this.awaitingSearch && this.search.length > 0) {
        await this.fetchResults({ query: this.search });
        setTimeout(() => {
          this.awaitingSearch = false;
        }, 500); // 1 sec delay
      }
      this.awaitingSearch = true;
    },

    // isBookmarked(crimeId) {
    //   if (this.bookmarked.indexOf(crimeId) !== -1) return "checked";
    //   else return "";
    // },

    // showCrimePropertiesSearchPanel() {
    //   this.showCrimePropertiesSearch = true;
    // },

    // async onCloneAndAdddButton(cloneSrc) {
    //   if (this.BeginDate != "") {
    //     let token = this.app_token;
    //     let postdata = {
    //       Id: cloneSrc.Id,
    //       BeginDate: this.BeginDate,
    //       EndDate: this.EndDate,
    //     };

    //     this.message = "";

    //     await axios
    //       .post(process.env.VUE_APP_ENDPOINT + "/api/clone-crime-record", postdata, {
    //         headers: { Authorization: `Bearer ` + token },
    //       })
    //       .then((crime) => {
    //         const crimeId = crime.data.clone[0]; // new record Id (PK)
    //         this.clonePanelShow = false;
    //         this.fetchResults({ query: this.search });
    //         this.onAdd(crimeId);
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //       });
    //   } else {
    //     this.message = "Begin Date must have a correct date value";
    //   }
    // },

    // async onAddBookmarkedButton(cloneSrc) {
    //   // console.log("onAddBookmarkedButton:::", cloneSrc);

    //   this.$emit("closeCrimeTable", {
    //     currentCount: this.currentCountModel,
    //     // CrimeState: this.CrimeState,
    //     bookmarked: this.bookmarked,
    //     enhancementMatches: this.enhMatches,
    //   });
    // },

    // async onCloneOnlyButton(cloneSrc) {
    //   // console.log("onCloneOnlyButton:::", cloneSrc);

    //   if (this.BeginDate != "") {
    //     let token = this.app_token;
    //     // console.log(
    //     //   "addressurl:::",
    //     //   process.env.VUE_APP_ENDPOINT + "/api/clone-crime-record",

    //     //   "TOKEN:::",
    //     //   { Authorization: `Bearer ` + token }
    //     // );

    //     let postdata = {
    //       Id: cloneSrc.Id,
    //       BeginDate: this.BeginDate,
    //       EndDate: this.EndDate,
    //     };

    //     this.message = "";

    //     await axios
    //       .post(process.env.VUE_APP_ENDPOINT + "/api/clone-crime-record", postdata, {
    //         headers: { Authorization: `Bearer ` + token },
    //       })
    //       .then((crime) => {
    //         const crimeId = crime.data.clone[0]; // new record Id (PK)
    //         this.clonePanelShow = false;

    //         this.search = cloneSrc.statuteDefinitionSectionNumber;

    //         this.fetchResults({ query: this.search });
    //         //this.onAdd(crimeId);
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //       });
    //   } else {
    //     this.message = "Begin Date must have a correct date value";
    //   }
    // },

    // loadTopBtnClick(r) {
    //   this.search = r.statuteDefinitionSectionNumber;
    // },

    // loadBottomBtnClick(r) {
    //   this.search = r.statuteDefinitionSectionNumber;
    // },

    clickRow(r, i, len) {
      const foundRow = this.rows.find((crime) => crime.sel === 1);
      if (foundRow) {
        foundRow.sel = 0;
      }
      r.sel = 1;

      // this.selectionCountValue = this.currentCountModel;
      // if (r.CrimeTypeId == 1 || r.CrimeTypeId == 3) {
      //   this.showCount = true;
      //   this.selectionCountValue = 0;
      // } else if (r.CrimeTypeId == 6 || r.CrimeTypeId == 2) {
      //   this.showCount = true;
      // } else {
      //   this.showCount = false;
      // }
    },

    emitLawText(obj) {
      this.$emit("displayModalPopup", obj);
    },

    // hoverRow(r, i, len) {
    //   // console.log('rrr::>', r, 'i:::', i);
    //   //this.search = r.statuteDefinitionSectionNumber;
    //   //console.log(len-1, i);
    //   // console.log(this.startScroll)

    //   SC.sleep(500).then((s) => {
    //     if (i == 0) {
    //       // console.log("--top--");
    //       //this.search = r.statuteDefinitionSectionNumber;
    //       this.loadtop = true;
    //     }

    //     if (i == len - 1) {
    //       // console.log("--bottom--");
    //       //this.search = r.statuteDefinitionSectionNumber;
    //       this.loadbottom = true;
    //     }
    //   });
    // },

    // cloneButton(r) {
    //   this.clonePanelShow = false;

    //   SC.sleep(500).then((n) => {
    //     this.reanimate = true;
    //     this.clonePanelShow = true;

    //     this.cloneSourceRecord = r;

    //     this.BeginDate = new Date().getFullYear() + "-01-01";
    //     this.EndDate = new Date().getFullYear() - 1 + "-12-31";

    //     this.message = "";
    //   });
    // },

    // onClonePanelClose() {
    //   this.clonePanelShow = false;
    // },

    // onSevChange(event) {
    //   //console.log('***** EVENT:::', event , '*****');
    //   this.fetchResults({ query: this.search });
    // },

    // onSevTypeChange(event) {
    //   // console.log('***** EVENT:::', event , '*****');
    //   //this.fetchResults({ query: this.search });
    //   if (this.search?.length > 0) {
    //     this.manualSearch();
    //   }
    // },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      this.window.gridheight = this.window.height * 0.65 - 20;

      //document.getElementById("gridscroll").height = this.window.height;
      //console.log('gridscrollgridscroll::', this.$refs.gridscroll)
      // :style="{ 'height': ` ${window.height} ` }"
      //console.log('offsetHeightoffsetHeight::', document.getElementById("gridscroll"));
    },

    // onCurrentCountChange(v) {
    //   this.countSpinnerTouched = true;

    //   // console.log("currentcountchange:::", v, this.countSpinnerTouched);
    // },

    onClose() {
      this.$emit("close");
    },

    async onAdd(crimeId, row) {
      // console.log("ON ADD", row);
      this.selectedCrimeId = crimeId;
      this.selectedR = row;
      const oldSelectedIndex = this.rows.findIndex((crime) => crime.sel === 1);
      if (oldSelectedIndex !== -1) {
        this.rows[oldSelectedIndex].sel = 0;
      }
      const newSelectedIndex = this.rows.findIndex((crime) => crime.Id == crimeId);
      this.rows[newSelectedIndex].sel = 1;
      this.showAddChargeModal = true;
    },

    // setSelectionToCharges(CPK) {
    //   // console.log("SET SELECTION TO CHARGES", CPK);
    //   this.CPK = CPK.CPKItem;
    //   this.CPK.crimeId = CPK.CPKItem.CrimeId;
    //   this.CPK.ChargedPer = CPK.ChargedPer;

    //   this.selectionCharge = {
    //     crimeId: CPK.CPKItem.CrimeId,
    //     currentCount: this.currentCountModel,
    //     ChargedPer: CPK.ChargedPer,
    //     CrimeState: CPK.CrimeState,
    //     enhancementMatches: this.enhMatches,
    //   };

    //   // console.log("setSelectionToCharges::::", this.selectionCharge);
    // },

    // addSelectionToCharges(CPK) {
    //   // console.log("addSelectionToCharges***::CPKItem:::", CPK, CPK.CPKItem.CrimeId);
    //   //
    //   if (CPK.CPKItem?.CrimeId !== undefined) {
    //     this.currentCountModel = CPK.countValue;
    //     // CPK = CPK.CPKItem;
    //     // CPK.countValue = this.currentCountModel;
    //     // console.log("ADDS A CPK");
    //     this.$emit("closeCrimeTable", {
    //       crimeId: CPK.CPKItem.CrimeId,
    //       currentCount: CPK.CPKItem.countValue || this.currentCountModel,
    //       ChargedPer: CPK.CPKItem.ChargedPer,
    //       CrimeState: CPK.CrimeState,
    //       OffenseDate: this.bDate,
    //       DateRangeEnd: this.eDate,

    //       // enhancementMatches: this.enhMatches,
    //       isEnhancementMatch: CPK.CPKItem.isEnhancementMatch,
    //     });
    //     this.showCPK = false;
    //     this.CPK = null;
    //   } else {
    //     // console.log("ADDS A NON CPK", this.selectedCrimeId);
    //     this.closeCPK({
    //       crimeId: this.selectedCrimeId,
    //       isEnhancementMatch: CPK?.isEnhancementMatch,
    //       currentCount: CPK.countValue,
    //       CrimeState: CPK.CrimeState,
    //       OffenseDate: this.bDate,
    //       DateRangeEnd: this.eDate,
    //     });
    //   }
    //   // this.CPK = null
    //   this.showCountPanel = false;
    // },

    addCharge(newChargeData, remount, alreadyHadBeginDate) {
      this.showAddChargeModal = false;
      if (!alreadyHadBeginDate) {
        newChargeData.OffenseDate = this.bDate;
        if (this.rangeCheck && this.eDate.length > 0) {
          newChargeData.DateRangeEnd = this.eDate;
        }
      }

      this.$emit("addChargesFromCrimeTable", newChargeData, remount, this.insertChargeCountNumber);
    },

    beforeLeave() {},

    afterEnter() {
      if (this.currentCount == 0) this.currentCount = 1;
      this.currentCountModel = this.currentCount;

      this.countSpinnerTouched = false;
    },

    fetchResults(data) {
      this.load_searched_crimes(data.query);
    },

    async load_crimes(uri) {
      this.rows = {};

      // SC.sleep(200).then((s) => {
      let token = this.app_token;

      // console.log("severityPicked::severityPicked::", this.severityPicked);
      this.severity = this.severityPicked.charAt(0);

      // uri =
      //   uri +
      // "&severity=" +
      // this.severity +
      // "&severityType=" +
      // this.CrimeState +
      // "&seriousFelony=" +
      // this.sp.seriousFelony +
      // "&violentFelonies=" +
      // this.sp.violentFelonies +
      // "&strike=" +
      // this.sp.strike +
      // "&superStrike=" +
      // this.sp.superStrike +
      // "&threeStrikeTrigger=" +
      // this.sp.threeStrikeTrigger +
      // "&sexRegistration=" +
      // this.sp.sexRegistration +
      // "&arsonRegistration=" +
      // this.sp.arsonRegistration +
      // "&gangRegistration=" +
      // this.sp.gangRegistration +
      // "&firearmIneligible=" +
      // this.sp.firearmIneligible +
      // "&voteIneligible=" +
      // this.sp.voteIneligible +
      // "&jurySvcIneligible=" +
      // this.sp.jurySvcIneligible +
      // "&dnaSamples=" +
      // this.sp.dnaSamples +
      // "&pc1170h=" +
      // null;

      if (this.sp.description !== "") uri += "&description=" + this.sp.description;

      if (this.rangeCheck && this.eDate.length > 0) {
        uri = uri + "&bDate=" + this.eDate;
      } else {
        if (this.bDate.length == 0) {
          this.bDate = new moment().format("YYYY-MM-DD");
        }
        uri = uri + "&bDate=" + this.bDate;
      }

      // if (this.eDate || this.bDate.length > 0) {
      //   uri = uri + "&bDate=" + (this.eDate ? this.eDate : this.bDate);
      // } else if (this.bDate.length == 0) {

      // }
      // if (this.rangeCheck == true) {
      //   if (this.eDate.length > 0) uri = uri + "&eDate=" + this.eDate;
      // }

      // console.log("uri:::uri:::uri:::", uri);

      let response = fetch(uri, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          cache: "no-store",
          "Cache-Control": "no-cache",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("from getAllCrimes:", data.length);

          // let selCount = 0,
          //   c = 0;
          // data.content.forEach((element) => {
          //   if (
          //     element.sel == "1" &&
          //     (element.crmCatName.toUpperCase().includes("FELONIES") ||
          //       element.crmSeverityName.toUpperCase().includes("FELONY"))
          //   ) {
          //     selCount++;
          //   }

          //   if (selCount == 1) {
          //     data.content[c++]["sel"] = 1;
          //     selCount++;
          //   } else data.content[c++]["sel"] = 0;
          // });
          if (data.content?.length > 0) {
            let selectedIndex = 0;
            if (data.content?.length == 31) {
              selectedIndex = 15;
            } else {
              selectedIndex = data.content.findIndex((crime) => crime.statuteDefinitionSection?.includes(this.search));
            }
            // console.log("SELECTED INDEX", selectedIndex);
            data.content.forEach((crime, index) => {
              if (index == selectedIndex) {
                crime.sel = 1;
              } else {
                crime.sel = 0;
              }
            });

            // console.log("from getAllCrimes2:", data);

            this.rows = data.content;
            this.pagebuttons = data.page_buttons;
            this.page = data.page;
            this.pages = data.pages;

            // console.log("from this.rows:", this.rows[0]);

            this.$nextTick(() => {
              // console.log("scrollcount:::", this.scrollcount++);
              if (this.rows.length == 31) {
                this.scrollToRow(Math.floor(this.rows.length / 2));
              } else {
                this.scrollToRow(selectedIndex);
              }
            });
            this.badSearch = false;

            this.showCrimePropertiesSearch = false;
            this.sp.description = "";
            this.sp.seriousFelony = this.sp.violentFelonies = this.sp.strike = this.sp.superStrike = this.sp.threeStrikeTrigger = this.sp.sexRegistration = this.sp.arsonRegistration = this.sp.gangRegistration = this.sp.firearmIneligible = this.sp.voteIneligible = this.sp.jurySvcIneligible = this.sp.dnaSamples = this.sp.pc1170h = false;
          } else {
            this.rows = [];
            this.badSearch = true;
          }
        })
        .catch(handleError);

      // });
    },

    // async deleteButton(r, i) {
    //   let token = this.app_token;

    //   // console.log("crime-record>>>", r);

    //   this.$confirm.require({
    //     message: "Are you sure you want to proceed?",
    //     header: "Confirmation",
    //     icon: "pi pi-exclamation-triangle",
    //     accept: () => {
    //       axios
    //         .delete(process.env.VUE_APP_ENDPOINT + "/api/crimes/" + r.Id, {
    //           headers: { Authorization: `Bearer ` + token },
    //         })
    //         .then((d) => {
    //           this.rows.splice(i, 1);
    //         });
    //     },
    //     reject: () => {
    //       //callback to execute when user rejects the action
    //     },
    //   });
    // },

    scrollToRow(index) {
      try {
        this.$nextTick(() => {
          var elmnt = document.getElementById("row_" + index);
          elmnt.scrollIntoView({ behavior: "auto", block: "center" });
        });
      } catch (e) {
        console.error(e);
      }

      // console.log('index.index.index.:::', index);
      // this.scrollTo(this.selected);

      //console.log(this.$refs.rows[index]);

      //.$el.scrollIntoView({ behavior: 'smooth' });

      // const tbody = this.$refs.table.$el.querySelector('tbody')
      // const row = tbody.querySelectorAll('tr')[index]

      //row.scrollIntoView( { behavior: 'smooth' } )
    },

    load_searched_crimes(searchText) {
      this.selFlag = false;

      // console.log("searchText:::>>>", searchText);

      let uri = process.env.VUE_APP_ENDPOINT + "/api/crimes/search?statute=" + searchText;
      //this.showCaseDetails = true;

      this.load_crimes(uri);
    },

    // load_default_crimes() {
    //   this.selFlag = false;
    //   let uri =
    //     process.env.VUE_APP_ENDPOINT + "/api/crimes/search?statute=" + this.defcrime;

    //   this.load_crimes(uri);
    // },

    selectedRow(r) {
      if (r.sel == "1" && r.crmCatName.toUpperCase().includes("FELONY")) {
        this.selectedRowFlag = "1";

        // if (this.selFlag == false) {
        //     this.selFlag = true;
        //     this.selectedRowFlag = '1';
        //     return '1';
        // } else  {
        //     this.selFlag = false;
        //     this.selectedRowFlag = '0';
        //     return '0';
        // }
      }
    },

    async scrollBottom() {
      this.window.onscroll = () => {
        let isBottom =
          document.documentElement.scrollTop + this.window.innerHeight === document.documentElement.offsetHeight;
        // console.log(isBottom);
      };
    },

    async wheelUp(event) {
      const top = event.currentTarget.scrollTop;
      const scrollHeight = event.currentTarget.scrollHeight;
      // console.log(top, event.currentTarget.scrollHeight)
      // console.log(this.rows.length);
      // console.log(top / 55)
      if (!this.awaitingSearch) {
        // console.log('start search')

        if (top < 300) {
          const token = localStorage.getItem("user_token");
          // console.log(this.rows[0])
          // console.log(process.env.VUE_APP_ENDPOINT + `/api/crimes/getMore?sortNumber=${this.rows[0]?.LegacySortOrder}&direction=up`)
          this.awaitingSearch = true;
          const fetchedCrimes = await axios
            .post(
              process.env.VUE_APP_ENDPOINT + `/api/crimes/getMore`,
              {
                direction: "up",
                sortNumber: this.rows[0]?.LegacySortOrder,
                BeginDate: this.bDate,
              },
              {
                headers: { Authorization: `Bearer ` + token },
              }
            )
            .then((result) => {
              // console.log(result);
              if (result.data?.length > 0) {
                result.data.forEach((crime) => {
                  const foundIndex = this.rows.findIndex((c) => c.Id == crime.Id);
                  if (foundIndex == -1) {
                    this.rows.unshift(crime);
                  }
                });
                this.$nextTick(() => {
                  this.scrollToRow(result.data.length);
                });
                this.awaitingSearch = false;
              }
            })
            .catch(handleError);
        } else if (top > scrollHeight - 1000) {
          const token = localStorage.getItem("user_token");
          // console.log(this.rows[0])
          // console.log('BOTTOM')
          this.awaitingSearch = true;
          const fetchedCrimes = await axios
            .post(
              process.env.VUE_APP_ENDPOINT + `/api/crimes/getMore`,
              {
                direction: "down",
                sortNumber: this.rows[this.rows.length - 1]?.LegacySortOrder,
                BeginDate: this.eDate ? this.eDate : this.bDate,
              },
              {
                headers: { Authorization: `Bearer ` + token },
              }
            )
            .then((result) => {
              // console.log(result)
              if (result.data?.length > 0) {
                result.data.forEach((crime) => {
                  const foundIndex = this.rows.findIndex((c) => c.Id == crime.Id);
                  if (foundIndex == -1) {
                    this.rows.push(crime);
                  }
                });
                this.$nextTick(() => {
                  this.scrollToRow(this.rows?.length - result.data.length);
                });
              }
            })
            .catch(handleError);
        }
        this.awaitingSearch = false;
      }
    },
    findBottom(event) {
      // console.log(event);
    },
  },

  mounted() {
    const nowDate = moment(new Date()).format("YYYY-MM-DD");
    // console.log(this.charges);

    // console.log(nowDate);
    // console.log(this.charges[0].Date);
    this.bDate = this.charges[0]?.Date ? moment(this.charges[0].Date).format("YYYY-MM-DD") : nowDate;
    // console.log(this.bDate);
    this.BeginDate = this.bDate;
    // this.eDate = this.bDate;
    this.currentCountModel = this.currentCount == 0 ? 1 : this.currentCount;
    //this.load_default_crimes();
    // console.log(this.app_token, process.env.VUE_APP_ENDPOINT);

    this.$nextTick(() => {
      this.$refs.crimeSearchInput.focus();
      this.$refs.crimeSearchInput.select();
      this.searchBarElement = this.$refs.searchBarContainer;
    });
  },
};
</script>

<style scoped>
.no-body-padding .modal-body {
  padding: 0 !important;
}

thead {
  position: sticky;
  top: -5px;
  padding: 0.5rem 0;
}

/* gets rid of the padding in modal-body */
:deep(.modal-body) {
  padding: 0 !important;
}

:deep(.modal-header) {
  padding: 0.75rem !important;
}

.fc-normal {
  color: var(--primary-font) !important;
}

.wrapper::-webkit-scrollbar {
  display: show;
}

tbody {
  min-height: 50vh;
  max-height: 50vh;
  overflow: auto;
}

.modal-content {
  height: 85vh;
}

.mh-100 {
  max-height: 100vh !important;
}

.crimeRow > td {
  padding: 1rem;
}
</style>
